import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SyncVendorEntityField extends DexResourceModel {

    @Field(String)
    public name: string = '';

    @Field(String)
    public description: string | null = '';

    @Field(String)
    public syncEntityField_uuid: string = '';

    @Field(String)
    public SyncVendorEntity_uuid: string = '';

    @Field(String)
    public translationFunctionIn: string | null = '';

    @Field(String)
    public translationFunctionOut: string | null = '';

    @Field(String)
    public vendorName: string = '';

    @Field(String)
    public syncEntityName: string = '';

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
